import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

/**
 * Renders an option for use inside a select element.
 * It is recommended to use the Select component as a wrapper.
 */
const Option = ({children, value, dataIcon, ...props}) => (
    <option
        {...props}
        className={classNames({circle: dataIcon})}
        data-icon={dataIcon}
        value={value}>
        {children}
    </option>
);


Option.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
    ]),
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    label: PropTypes.string,
    dataIcon: PropTypes.string,
};

export default Option;



// WEBPACK FOOTER //
// ./scripts/components/Option.js